import React, { type MouseEvent } from "react";

import clsx from "clsx";

import { Select } from "@shared/selects";

import { useSalesViews } from "../sales-views-context";

const mayOpenNewTab = (value: string | null) => (event: MouseEvent) => {
  event.persist();

  if ((event.ctrlKey || event.metaKey || event.type === "auxclick") && value) {
    event.stopPropagation();

    const savedViewsUrl = new URL(window.location.href);
    savedViewsUrl.searchParams.set("savedView", value);
    window.open(savedViewsUrl.href, "_blank");
    return true;
  }

  return false;
};

export const SavedViewsSelect = () => {
  const { salesViews, selectSalesView, selectedSalesViewId } = useSalesViews();

  const salesViewsOptions = salesViews.map((view) => ({
    value: view.id,
    label: view.name,
  }));

  return (
    <Select
      className="w-72"
      options={salesViewsOptions}
      value={selectedSalesViewId}
      onChange={selectSalesView}
      menuItemRender={({ option, value, onChange, active, selected }) => (
        <div
          className={clsx(
            (active || selected) && !option.disabled
              ? "bg-cosmic-3 font-semibold"
              : "hover:bg-cosmic-4",
            option.disabled && "bg-gray-3 pointer-events-none",
            "px-4 py-2 cursor-pointer text-interstellar font-normal",
          )}
          onClick={(event: MouseEvent) => {
            const didOpenNewTab = mayOpenNewTab(value)(event);
            if (!didOpenNewTab) {
              onChange(option.value);
            }
          }}
          onAuxClick={(event: MouseEvent) => mayOpenNewTab(value)(event)}
        >
          {option.label}
        </div>
      )}
    />
  );
};
